import { render, staticRenderFns } from "./BaseCheckboxReg.vue?vue&type=template&id=5e40d9a4&scoped=true&"
import script from "./BaseCheckboxReg.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxReg.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckboxReg.vue?vue&type=style&index=0&id=5e40d9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40d9a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
